import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Breadcrumbs, Grid } from "@material-ui/core";
// import Create from "@material-ui/icons/Create";
import AssessmentIcon from '@material-ui/icons/Assessment';
import Search from "@material-ui/icons/Search";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import IsoIcon from '@material-ui/icons/Iso';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import { useEffect } from "react";
import { fetchLocalidades } from "../../actions/cbos/localidades";
import { fetchPlanes } from "../../actions/cbos/planes";
import { desSeleccionarAfiliado, desSeleccionarAfiliadoConsulta } from "../../actions/afiliado";
import { changeStepper } from "../../actions/preAfiliado/stepper";
import { IngresoTurnos } from "./nuevo/IngresoTurnos";
import { ListaTurnos } from "./consultaTurnos/ListaTurnos";
import { RecepcionDiaria } from "./recepcionDiaria/RecepcionDiaria";
// import { HomeCambiosEnAgenda } from "./cambiosAgenda/HomeCambiosEnAgenda";
import { TURNOS_PERMISOS, ARQUEO_PERMISOS } from "../../utils/permisos";
import { BreadcrumbsItemsCustom } from "../BreadcrumbsItemsCustom";
import { BajaMasiva } from "./bajaMasiva/BajaMasiva";
import { ConsultaProfesional } from "./consultaProfesional/ConsultaProfesional";
import { HomeConsultaBajas } from "./consultaBajas/HomeConsultaBajas";
import { ArqueoPorCentroMedico } from "../reportes/ArqueoPorCentroMedico";
import { BuscadorParaTurnos } from "../afiliaciones/BuscadorParaTurnos";
import { ImageSearch } from "@material-ui/icons";
import { HomeEstudiosMedicos } from "./estudiosMedicos/HomeEstudiosMedicos";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "98%",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  colorSeleccionado: theme.palette.text.primary,
  colorDeseleccionado: theme.palette.text.secondary,
}));

export const HomeTurnos = (props) => {

  const classes = useStyles();
  const { seleccionadoConsulta } = useSelector((state) => state.afiliacion);

  const [menu, setMenu] = useState(0);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  // const [mostrar6, setMostrar6] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);
  const [mostrar8, setMostrar8] = useState(false);
  const [mostrar9, setMostrar9] = useState(false);

  const [idObraSocial, setIdObraSocial] = useState(null);

  const buttons = [
    {
      validarAlgunPermiso: [],
      permiso: TURNOS_PERMISOS.ALTA,
      color: menu === 1 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: 'btnAlta',
      text: 'Nuevo',
      icon: IsoIcon,
    },
    {
      validarAlgunPermiso: [],
      permiso: TURNOS_PERMISOS.ALTA,
      color: menu === 2 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: 'btnRecepcionDiaria',
      text: 'Recepcion Diaria',
      icon: PersonAddIcon,
    },
    {
      validarAlgunPermiso: [],
      permiso: TURNOS_PERMISOS.CONSULTA,
      color: menu === 3 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: 'btnConsulta',
      text: 'Consulta Por Afiliado',
      icon: Search,
    },
    {
      validarAlgunPermiso: [],
      permiso: TURNOS_PERMISOS.CONSULTA,
      color: menu === 5 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: 'btnConsultaProfesional',
      text: 'Consulta Por Profesional',
      icon: Search,
    },
    {
      validarAlgunPermiso: [],
      permiso: TURNOS_PERMISOS.CANCELAR,
      color: menu === 4 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: 'btnBaja',
      text: 'Eliminar Turnos',
      icon: DeleteForeverIcon,
    },
    {
      validarAlgunPermiso: [],
      permiso: TURNOS_PERMISOS.CONSULTA,
      color: menu === 7 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: 'btnConsultaBajas',
      text: 'Consulta Bajas',
      icon: ZoomOutIcon,
    },
    {
      validarAlgunPermiso: [ARQUEO_PERMISOS.ARQUEO_VER_SOLO_CENTRO_MEDICO, ARQUEO_PERMISOS.ARQUEO_VER_TODOS_CM],
      color: menu === 8 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: 'btnArqueo',
      text: 'Arqueo Coseguros',
      icon: AssessmentIcon,
      permiso: {}
    },
    {
      validarAlgunPermiso: [],
      permiso: TURNOS_PERMISOS.BANDEJA_ESTUDIOS_MEDICOS,
      color: menu === 9 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: 'btnEstudiosMedicos',
      text: 'Estudios Médicos',
      icon: ImageSearch,
    },
  ]

  const { cargada: listaLocCargada } = useSelector(
    (state) => state.localidades
  );
  const { cargada: listaPlanesCargada } = useSelector(
    (state) => state.planes
  );

  const [checkingData, setCheckingData] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!listaPlanesCargada)
      dispatch(fetchPlanes());
    else if (!listaLocCargada)
      dispatch(fetchLocalidades());

    setCheckingData(false);
  }, [dispatch, listaPlanesCargada, listaLocCargada]);

  //****************************************** */
  const handleClick = (e) => {
    e.preventDefault();
    switch (e.currentTarget.name) {
      case "btnAlta":
        dispatch(desSeleccionarAfiliado());
        dispatch(changeStepper(0));
        setMostrar1(true);
        setMenu(1);
        break;
      case "btnRecepcionDiaria":
        setMostrar2(true);
        setMenu(2);
        break;
      case "btnConsulta":
        dispatch(desSeleccionarAfiliadoConsulta());
        setMostrar3(true);
        setMenu(3);
        break;
      case "btnBaja":
        setMostrar4(true)
        setMenu(4);
        break;
      case "btnConsultaProfesional":
        setMostrar5(true)
        setMenu(5);
        break;
      case "btnConsultaBajas":
        setMostrar7(true)
        setMenu(7);
        break;
      case "btnArqueo":
        setMostrar8(true)
        setMenu(8);
        break;
      case "btnEstudiosMedicos":
        setMostrar9(true)
        setMenu(9);
        break;
      default:
        break;
    }
  };

  if (checkingData) {
    return <h1>Cargando....</h1>;
  }

  return (
    <>
      <div className={classes.root}>
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12} styles={{ padding: 5 }}>
            <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
              <BreadcrumbsItemsCustom
                buttons={buttons}
                handleClick={handleClick}
              />
            </Breadcrumbs>
          </Grid>
          {(mostrar1 && menu === 1) && <Grid container justify="center"><IngresoTurnos /></Grid>}
          {/* {(seleccionadoConsulta && menu === 1) && <TabAfiliacion idForm="formConsulta" />} */}

          {/* {(mostrar2 && menu === 2) && <Grid item xs={12} sm={4} md={8}><RecepcionDiaria /></Grid>} */}
          {(mostrar2 && menu === 2) && <RecepcionDiaria />}

          {(mostrar3 && menu === 3) && <Grid item xs={12} sm={10} md={6}><BuscadorParaTurnos idConsulta={"idConsulta"} idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial} /></Grid>}
          {(seleccionadoConsulta && menu === 3) && <ListaTurnos idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial} />}

          {(mostrar4 && menu === 4) && <Grid><BajaMasiva /></Grid>}

          {(mostrar5 && menu === 5) && <Grid><ConsultaProfesional /></Grid>}

          {/* {(mostrar6 && menu === 6) && <Grid><HomeCambiosEnAgenda /></Grid>} */}

          {(mostrar7 && menu === 7) && <Grid><HomeConsultaBajas /></Grid>}

          {(mostrar8 && menu === 8) && <Grid><ArqueoPorCentroMedico /></Grid>}

          {(mostrar9 && menu === 9) && <Grid><HomeEstudiosMedicos {...props}/></Grid>}
        </Grid>
      </div>
    </>
  );
};
